<template>
  <div id="app">
    <div class="container">
      <div class="title">登录</div>
      <div class="form">
        <div class="logo"><img src=".././assets/img/logo.png" > </div>
        <div class="textbox">
          <img src=".././assets/img/手机.png" alt="">
          <input type="text" placeholder="请输入用户名" v-model="usrLogin" @focus="getFocus">
        </div>
        <div class="textbox">
          <img src=".././assets/img/密码.png" alt="">
          <input type="password" placeholder="请输入密码" v-model='usrPwd' @focus="getFocus">
        </div>
        <div class="code">
          <span @click="codeLogin">
            验证码登陆
          </span>
        </div>
      </div>
      <img src=".././assets/img/按钮.png" class="btn" @click="login"> 
    </div>
  </div>
</template>
<script>
import qs from 'qs'
import {pswLogin} from '@/api'
export default {
  data() {
    return {
      usrLogin :'',
      usrPwd :''
    }
  },
  created(){
    let token = window.localStorage.getItem('token')
    if(token==null){
      console.log('未登录')
    }else{
      this.$router.go(-1)
    }
  },
  methods:{
    //登陆按钮
    async login(){
      let params = {
        account:this.usrLogin,
        passwd:this.usrPwd,
        scene:1
      }
      if(this.usrLogin==''){
        this.$toast({message:'请输入用户名',duration:'3000'})
      }else if(this.usrPwd==''){
        this.$toast({message:'请输入密码',duration:'3000'})        
      }else{
        let res = await pswLogin(qs.stringify(params))
        if(res.status===1){
          window.localStorage.setItem('token',res.result.token)
          this.$router.go(-1)
        }else{
          this.$toast({message:res.msg,duration:'3000'}) 
        }
      }
    },
    // 键盘消失后页面回弹
    getFocus(){
      let input=document.getElementsByTagName('input')
      input.blur=function(){
        window.scroll(0, 0);
      }
    },
    // 快捷登陆
    codeLogin(){
      this.$router.push('/codeLogin')
    }
  }
}
</script>

<style lang="less" scoped>
#app{
  width: 750px;
  height: 95vh;
  background-color: #ffffff;
  .container{
    padding: 0 62px 0 68px;
    .title{
      font-size: 16PX;
      height: 120px;
      text-align: center;
      line-height: 120px;
      margin-bottom: 80px;
    }
    .form{
      position: relative;
      .logo{
        margin: 0 auto;
        width: 429px;
        height: 131px;
        margin-bottom: 150px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .textbox{
        position: relative;
        img{
          position: absolute;
          bottom: 20px;
          left: 0;
        }
        input{
          outline: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          width: 550px;
          margin-top: 60px;
          padding: 0 0 20px 50px;
          border: none;
          font-size: 16PX;
          border-bottom: 2px solid #dddddd;
          
        }
      }
      .code{
        width: 100%;
        height: 80px;
        line-height: 80px;
        text-align: right;
        padding: 0 20px;
        box-sizing: border-box;
        
        span{
          float: right;
          text-align: right;
          width: 160px;
        }
      }
    }
    .btn{
      margin-top: 90px;
      width: 620px;
      height: 90px;
    }
  }
}
</style>
